import React from "react";
import Navigation from "../../components/Navigation/Navigation";
import Logo from "../../components/Logo/Logo";

import "./style.scss";

const Header = () => {
  return (
    <header className="header">
      <Logo />
      <Navigation />
    </header>
  );
};

export default Header;
